"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_GROUP_CHAT_FAILED = exports.CREATE_GROUP_CHAT_SUCCEEDED = exports.CREATE_GROUP_CHAT_REQUESTED = void 0;
const service_1 = __importDefault(require("../../services/chats/service"));
const chatFunctions = __importStar(require("../../domain/model/chats"));
const sendMessage_1 = __importDefault(require("./sendMessage"));
const Stopwatch_1 = __importDefault(require("../../utils/Stopwatch"));
exports.CREATE_GROUP_CHAT_REQUESTED = "CREATE_GROUP_CHAT_REQUESTED";
exports.CREATE_GROUP_CHAT_SUCCEEDED = "CREATE_GROUP_CHAT_SUCCEEDED";
exports.CREATE_GROUP_CHAT_FAILED = "CREATE_GROUP_CHAT_FAILED";
function default_1(subject, users, chatHistoryVisibleToNewJoiners) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const timer = Stopwatch_1.default.startNew();
        const chatId = chatFunctions.generateChatId();
        const requestEvent = {
            type: exports.CREATE_GROUP_CHAT_REQUESTED,
            payload: {
                chatId,
                subject,
                users
            }
        };
        dispatch(requestEvent);
        const response = yield service_1.default.createGroupChat(chatId, subject, users, chatHistoryVisibleToNewJoiners);
        if (response.kind !== "success") {
            dispatch({
                type: exports.CREATE_GROUP_CHAT_FAILED,
                payload: {
                    chatId,
                    subject,
                    users,
                    response
                }
            });
            return;
        }
        // Messages may have been added on the UI before the chat was confirmed on the back end. These messages will
        // have been added to the 'chat.unconfirmedMessages' array. So we need to read the values out of this array,
        // then apply the state change to confirm the chat, then send those messages using the new chatId.
        const oldChat = chatFunctions.getChat(getState().chatsState.chats, chatId)[0];
        dispatch({
            type: exports.CREATE_GROUP_CHAT_SUCCEEDED,
            payload: {
                chatId,
                chat: response.result,
                durationMs: timer.getElapsedMs()
            }
        });
        const messagesToSend = oldChat.messages;
        if (messagesToSend.length) {
            const chat = chatFunctions.getChat(getState().chatsState.chats, chatId)[0];
            messagesToSend.forEach(m => dispatch(sendMessage_1.default(chat, m.content, m.repliesTo)));
        }
    });
}
exports.default = default_1;
